import { ButtonProps, Button } from '@/ui/Button'

export interface Props extends Omit<ButtonProps, 'type'> {}

export const SubmitButton = (props: Props) => <Button {...props} type="submit" />
